import { fetchJson } from '@/lib/api';

export function parseTryBookingEventId(ticketUrl) {
  if (!ticketUrl) return null;
  const match = String(ticketUrl).match(
    /trybooking\.com\/(?:au|nz|uk|us)\/event\/(\d+)|trybooking\.com\/events\/(\d+)/i,
  );
  return match ? Number(match[1] || match[2]) : null;
}

export function buildTryBookingCheckoutUrl(eventId, sessionId, region = 'au') {
  return `https://www.trybooking.com/${region}/event/${eventId}/tickets?sessionId=${sessionId}`;
}

export async function fetchTryBookingSessions(eventId, query = {}) {
  const params = new URLSearchParams();
  if (query.price) params.set('price', query.price);
  if (query.subtitle) params.set('subtitle', query.subtitle);
  const suffix = params.toString() ? `?${params.toString()}` : '';
  return fetchJson(`/api/v1/trybooking/events/${eventId}/sessions${suffix}`);
}

export async function fetchTryBookingSessionsBySlug(slug) {
  return fetchJson(`/api/v1/trybooking/events/by-slug/${slug}/sessions`);
}

export function resolveCheckoutUrl(session, fallbackTicketUrl) {
  return session.ticketUrl || fallbackTicketUrl;
}
